import { Box } from '@mui/material';
import { FC } from 'react';
import { AiSmallButton as Icon } from '../../../../svg/custom.svg';

export const AiSmallButton: FC<IAiSmallButton> = ({ show, onShowAiBigButton }) => {
  return (
    <Box
      data-ph-action='ai-assistant-show'
      onClick={onShowAiBigButton}
      sx={{
        position: 'absolute',
        zIndex: 2,
        right: 0,
        bottom: '90px',
        width: '34px',
        height: '34px',
        cursor: 'pointer',
        visibility: show ? 'visible' : 'hidden',
        '& > svg': {
          width: '34px',
          height: '34px',
        },
      }}
    >
      <Icon />
    </Box>
  );
};

interface IAiSmallButton {
  show: boolean;
  onShowAiBigButton: () => void;
}
